import { useMemo } from "react";
import { useQueryString } from "../hooks";

export interface UTMParams {
  utmId?: string | null;
  utmSource?: string | null;
  utmMedium?: string | null;
  utmCampaign?: string | null;
  utmTerm?: string | null;
  utmContent?: string | null;
}

export interface UTMQueryParams {
  utm_id?: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_term?: string;
  utm_content?: string;
}

export function useUTMParams() {
  const queryParams: UTMQueryParams = useQueryString();

  return useMemo(() => {
    return {
      utmId: queryParams.utm_id,
      utmSource: queryParams.utm_source,
      utmMedium: queryParams.utm_medium,
      utmCampaign: queryParams.utm_campaign,
      utmTerm: queryParams.utm_term,
      utmContent: queryParams.utm_content,
    };
  }, [queryParams]);
}
